import { LOGIN_FAILURE, LOGIN_REQUEST, LOGIN_SUCCESS, LOGOUT } from "../Types";

const initialState = {
    loading: false,
    user: null,
    error: null,
    isInitialized: false, 
};

const LoginReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOGIN_REQUEST:
            return { ...state, loading: true, error: null };

        case LOGIN_SUCCESS:
            return {
                ...state,
                loading: false,
                user: action.payload,
                error: null,
                isInitialized: true, 
            };

        case LOGIN_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                user: null,
                isInitialized: true, 
            };

        case LOGOUT:
            return { ...initialState, isInitialized: true }; 
        default:
            return state;
    }
};

export default LoginReducer;
